import { observer } from 'mobx-react';
import { useCompetition, useRootStore } from '@nandosaus/state-management';
import { addThousandsSeparators } from '@nandosaus/state-management/lib/util/formatter';
import { useRouter } from 'next/router';
import React, { useState } from 'react';

import { AccountNavigation } from '../account-nav';
import { Box, Flex } from '../../grid';
import { fontSize, navigation } from '../../../constants';
import { Icon } from '../../icons';
import { P } from '../../typography/new';
import { NavLink } from '../../nav-link';
import { profileDefaultProps, profilePropTypes } from '../../../prop-types';
import { setLandingPage } from '../../../utils/auth';
import { useFeature } from '../../../hooks/use-feature';

const Profile = ({ profile, handleSignOut, dark }) => {
  const router = useRouter();
  const [isOpen, setIsOpen] = useState(false);
  const isSignedIn = !!profile;
  const { CompetitionStore } = useRootStore();
  const { isActive: isCompetitionActive } = useCompetition();
  const partialPointRedemptionEnabled = useFeature('partial-point-redemption-enabled');

  if (isSignedIn) {
    return (
      <Flex position="relative" data-testid="header-profile" alignItems="center">
        <Flex onClick={() => setIsOpen(!isOpen)} as="button">
          <Box position="relative" mr="9px">
            <Icon
              name="user"
              fill={dark ? 'white' : 'black'}
              width={{ xs: '32px', lg: '36px' }}
              height={{ xs: '32px', lg: '36px' }}
            />
            {CompetitionStore.competition?.entries > 0 && isCompetitionActive && (
              <Box
                position="absolute"
                top="0px"
                right="0px"
                backgroundColor="periRed"
                borderRadius="50%"
                width="16px"
                height="16px"
                fontSize={fontSize[14]}
                lineHeight="16px"
                textAlign="center"
                color="white"
              >
                {CompetitionStore.competition.entries}
              </Box>
            )}
          </Box>
          <Box textAlign="left">
            <P variant="small-semi-bold" color={dark ? 'white' : 'black'}>
              {profile.givenName}
            </P>
            {partialPointRedemptionEnabled ? (
              <Box display="flex" alignItems="center" gap="6px">
                <P as="span" variant="extra-small" color={dark ? 'white' : 'black'}>
                  ${addThousandsSeparators(profile.displayPointsInDollars)}
                </P>
                <Box height="8px" width="1px" backgroundColor="grey40" />
                <P
                  color={dark ? 'white' : 'black'}
                  variant="extra-small"
                >{`${profile.displayPoints.toLocaleString()} pts`}</P>
              </Box>
            ) : (
              <P variant="extra-small" color={dark ? 'white' : 'black'}>
                {profile.displayPoints.toLocaleString()} points
              </P>
            )}
          </Box>
        </Flex>
        {/* TODO: What really should go here? */}
        <AccountNavigation
          profile={profile}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          handleSignOut={handleSignOut}
        />
      </Flex>
    );
  }

  return (
    <NavLink
      href={navigation.SIGN_IN}
      onClick={() => {
        if (router.asPath === navigation.PERI_PERKS_REGISTRATION) {
          setLandingPage(navigation.HOME);
        } else {
          setLandingPage(router.asPath);
        }
      }}
    >
      <P variant="standard-link" color={dark ? 'white' : 'black'} textTransform="uppercase">
        Sign In
      </P>
    </NavLink>
  );
};

Profile.propTypes = profilePropTypes;
Profile.defaultProps = profileDefaultProps;

const ObservedProfile = observer(Profile);
export { ObservedProfile as Profile };
